import { useTunnusContext } from 'contexts/TunnusContext';
import { FC } from 'react';
import styles from './UserInitials.module.scss';

const UserInitials: FC = () => {
  const { userInformation } = useTunnusContext();
  return <div className={styles.initials}>{userInformation?.initials}</div>;
};

export { UserInitials };
